// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__6snzM","title":"FrontImage_title__1W97F"};